import React from 'react';

import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';

import StyleConfigurationTable from 'components/modules/custom-pages/components/StyleConfigurationTable';
import { StylePropType } from 'libs/proptypes';

import { STYLE_LABEL_MAP } from './SingleImageStyle.constants';
import { getContentImageCSSRules, getSingleImageCSSRules } from './SingleImageStyle.utils';

import './SingleImageStyle.scss';

const propTypes = {
  style: StylePropType,
  isBackground: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  recipeName: PropTypes.string,
};

const defaultProps = {
  style: {},
  isBackground: false,
  recipeName: '',
};

function SingleImageStyle({ style, isBackground, onChange, recipeName }) {
  let cssRules = getSingleImageCSSRules(recipeName, isBackground);
  if (isBackground) {
    cssRules = cssRules.concat(getContentImageCSSRules(recipeName));
  }

  return (
    <div className="single-image-style">
      <Header content="Styles" />
      <StyleConfigurationTable
        cssRules={cssRules}
        style={style}
        onChange={onChange}
        labelMap={STYLE_LABEL_MAP}
      />
    </div>
  );
}

SingleImageStyle.propTypes = propTypes;
SingleImageStyle.defaultProps = defaultProps;

export default SingleImageStyle;
